import cn from 'classnames';
import React from 'react';
import { l } from 'app/blocks/common/codes';
import { template } from 'app/blocks/common/utils';
import Action from 'app/blocks/Panel/actions/buttons/Button';
import { GrayView } from 'app/blocks/views/WidgetView';

import './SubmissionOverview.scss';

export type SubmissionOverviewProps = {
    className?: string;
    href?: string;
    target?: string;
    rel?: string;
    onSubmissionClick: () => void;
    submissionDateString: string;
};

export const SubmissionOverview: React.FC<SubmissionOverviewProps> = ({
    className,
    href,
    onSubmissionClick,
    rel,
    submissionDateString,
    target,
}) => {
    return (
        <GrayView
            actions={
                <Action
                    href={href}
                    item={{ code: 'submissionOverviewAction', title: 'Submission overview' }}
                    onClick={onSubmissionClick}
                    rel={rel}
                    target={target}
                >
                    {l('WIDGETS.SUBMISSION_OVERVIEW.ACTION_TITLE')}
                </Action>
            }
            className={cn('submissionOverview', className)}
            icon="receipt"
            seleniumid="submissionOverview"
            title={l('WIDGETS.SUBMISSION_OVERVIEW.TITLE')}
        >
            {template(l('WIDGETS.SUBMISSION_OVERVIEW.CONTENT'), { submissionDateString })}
        </GrayView>
    );
};
